import styled from 'styled-components'

export default styled.form`
  ${props => props.display ? 'display: none;' : ''}
`



// WEBPACK FOOTER //
// ./src/components/Form/FormContainer.js